import { useQuery } from "@tanstack/react-query";
import { questionService } from "@/services";

// Query keys for questions
export const questionKeys = {
  all: ['questions'],
  user: (userId) => [...questionKeys.all, 'user', userId],
};

/**
 * Hook for fetching user questions
 * @param {string|number} userId - User ID to fetch questions for
 * @param {object} options - Additional React Query options
 * @returns {object} Query result with questions data, loading state, etc.
 * 
 * @example
 * const { data: questions, isLoading, error } = useUserQuestions(userId);
 */
export const useUserQuestions = (userId, options = {}) => {
  return useQuery({
    queryKey: questionKeys.user(userId),
    queryFn: () => questionService.getQuestions(userId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    enabled: !!userId, // Only run if userId exists
    ...options
  });
}; 